import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterMedium } from "../../../components/FooterMedium";

import {
  Header,
  Pill,
  Speaker,
  Extra2,
  TextReviews,
  VideoReviewsWithCards,
  Partners,
  Form,
  main
} from "../../../components/LandingTemplates/krp";

import headerNav from "./data/headerNav.json";
import dataAZ from "../../../components/LandingTemplates/krp/data/_molodostmozga/dataAZ.json";
import * as screen1 from "./styles/screen1.module.scss";
import * as yours from "./styles/yours.module.scss";
import * as program from "./styles/program.module.scss";
const Screen1 = () => {
  return (
    <section id={"screen1"}>
      <div className={"container"}>
        <div className={screen1.screen1__innerContainer}>
          <div className={screen1.screen1__info}>
            <p className={screen1.screen1__subtitle}>Бесплатное онлайн-занятие</p>
            <p className={screen1.screen1__date}>ЗАВТРА в 20:00 мск</p>
          </div>
          <div className={screen1.screen1__mainInfo}>
            <h1 className={screen1.screen1__title}>Развитие памяти и тонус мозга</h1>
            <p className={screen1.screen1__doText}>Верните себе энергию и остроту ума!</p>
            <div className={screen1.screen1__btns}>
              <a href={"#widget"} className={main.mainBtn}>Зарегистрироваться</a>
              <a href={"#program"} className={screen1.screen1__prBtn}>Смотреть программу</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
const Yours = () => {
  return (
    <section className={yours.yours} id={"useful"}>
      <div className="container">
        <h2 className={main.mainTitle}>Этот вебинар для вас, если:</h2>
        <div className={yours.wrap}>
          <ul>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/icon-for-01.png" alt=""/>
              <p>Устаёте после работы и учёбы</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/icon-for-02.png" alt=""/>
              <p>Хотите успевать больше</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/icon-for-03.png" alt=""/>
              <p>Откладываете новое на потом</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/icon-for-04.png" alt=""/>
              <p>Чувствуете вязкость мышления</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/icon-for-05.png" alt=""/>
              <p>Забываете слова и медленно формулируете мысли</p>
            </li>
          </ul>
          <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/foryou-1.png" alt=""/>
        </div>
        <div className={yours.wrap}>
          <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/foryou-2.png" alt=""/>
          <ul>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/icon-for-06.png" alt=""/>
              <p>Постоянно учитесь</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/icon-for-07.png" alt=""/>
              <p>Работаете с большими объёмами информации</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/icon-for-08.png" alt=""/>
              <p>Хотите развить интеллектуальную выносливость</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/icon-for-09.png" alt=""/>
              <p>Задумываетесь о смене работы и повышении квалификации</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
const Program = () => {
  return (
    <section className={program.program} id={"program"}>
      <div className="container">
        <h2 className={main.mainTitle}>Что будет на вебинаре:</h2>
        <ul>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/programm-01.png" alt=""/>
            <h3>Узнаете как развить интеллектуальную выносливость</h3>
            <p>Разберемся почему мы устаём и как развить в себе выносливость, чтобы делать больше, а уставать меньше</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/programm-02.png" alt=""/>
            <h3>Научитесь эффективно работать с большим количеством информации</h3>
            <p>Узнаете способы эффективной работы с информацией, которым нас не обучали в школе. Поймете как быстрее и эффективнее обрабатывать большие массивы данных при работе и на учебе</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/krp_tonusmozga/programm-03.png" alt=""/>
            <h3>Вернете себе тонус и концентрацию</h3>
            <p>Попробуете на практике упражнения, которые могут вернуть вам энергию и концентрацию в течение дня. Сможете на себе проверить эффективность нашего подхода</p>
          </li>
        </ul>
        <a href={"#widget"} className={main.mainBtn}>Зарегистрироваться</a>
      </div>
    </section>
  );
};

const TITLE = 'Развитие памяти и тонус мозга';
const DESCRIPTION = 'Верните себе энергию и остроту ума! | Центр образовательных технологий Advance ✅ Уникальные методики обучения ☝️ Заходите!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION} gcCounter={true}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <Header data={headerNav} />

    <main>
      <Screen1/>
      <Yours/>
      <Program/>
      <Pill/>
      <Speaker
        title={"Ведущий"}
        speakerName={"Александр Згода"}
        speakerProf={"Генеральный и академический директор Advance"}
        speakerPhoto={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/az-big.png"}
        dataProfList={dataAZ}
        iconColor={'#FD4B04'}
      />
      <VideoReviewsWithCards/>
      <TextReviews/>
      <Extra2 sectionName={main.pt}/>
      <Partners/>
      <Form
        staticDate={'ЗАВТРА в 20:00 мск'}
        widget={<GetCourseWidget hash={'d50b96bea2a6954ae30fd22070611469b886db93'} id={'1065341'}/>}
      />
    </main>

    <FooterMedium />

  </DefaultLayout>
);

export default Page;
